import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiBook, FiZap, FiStar } = FiIcons;

const Courses = () => {
  const courses = [
    {
      icon: FiBook,
      title: 'Standard Driving Lessons',
      description: 'Regular lessons at your own pace with both manual and automatic options available.',
      features: ['Manual & Automatic', 'Flexible Scheduling', 'Personalized Pace']
    },
    {
      icon: FiZap,
      title: 'Intensive Courses',
      description: 'Pass your test faster with focused, concentrated lessons designed for quick results.',
      features: ['Fast-Track Learning', 'Concentrated Sessions', 'Quick Results']
    },
    {
      icon: FiStar,
      title: 'Advanced Courses',
      description: 'Specialized training including refresher lessons, Pass Plus, and motorway driving.',
      features: ['Refresher Lessons', 'Pass Plus', 'Motorway Driving']
    }
  ];

  return (
    <section className="py-20 bg-white dark:bg-gray-900 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4 transition-colors">
            Courses Offered
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto transition-colors">
            Choose the course that fits your needs and schedule.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {courses.map((course, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ y: -5 }}
              className="bg-gradient-to-br from-blue-50 to-white dark:from-gray-800 dark:to-gray-700 rounded-xl p-8 border border-blue-100 dark:border-gray-600 hover:shadow-lg transition-all duration-300"
            >
              <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mb-6">
                <SafeIcon icon={course.icon} className="w-6 h-6 text-white" />
              </div>
              
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3 transition-colors">{course.title}</h3>
              <p className="text-gray-600 dark:text-gray-300 mb-6 leading-relaxed transition-colors">{course.description}</p>
              
              <ul className="space-y-2">
                {course.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center gap-2">
                    <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                    <span className="text-gray-700 dark:text-gray-300 transition-colors">{feature}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Courses;